<div class="keyboard-container"> 
    <div class="keyboard-row"> 
        <button 
            class="keyboard-button" 
            *ngFor="let item of numericKeyboardButtons" 
            keyBoardStyle
            appKeyboardKey="{{ item }}"
        > 
            {{ item }} 
        </button>
        <button keyBoardStyle [isSpecial]="true" class="keyboard-backspace" (click)="onBackspace()">&larr;</button> 
        <button 
            class="keyboard-button" 
            keyBoardStyle
            appKeyboardKey="0" 
        > 
            0 
        </button> 
        <button 
            keyBoardStyle  
            [isSpecial]="true" 
            class="keyboard-clear" 
            (click)="onClear()" 
        > 
            CLEAR 
        </button> 
    </div> 
</div> 